module.exports = __webpack_public_path__ + "static/antd-card-loading-f6b23cb6c67efa86c86d326b1a50a5f6.gif";